export const gender = {
    labels: {
        gender: "Gênero",
        genders: "Gêneros",
        code: "Código",
        description: "Descrição",
        edit_gender: "Editar Gênero",
        name: "Nome",
        slug: "Slug",
    },
    placeholders: {
        code: "Exe: BR",
        description: "Informe a descrição",
        name: "Informe o nome",
        slug: "Exe: nome-da-url",
    },
    modals: {
        titles: {
            add_gender: "Adicionar Gênero",
            edit_gender: "Editar Gênero",
            del_gender: "Excluir Gênero",
        },
        messages: {
            del_gender: "Você deseja mesmo excluir o gênero <strong>{name}</strong>?<br/>Todos os relacionamentos deste gênero serão excluídos.",
        },
    },
    texts: {
    },
};
